require('./dropdownAccounts.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { HYPHEN } = require ('constants/index');
const { getLastNChars } = require('utilities/stringHelper');

class AccountItemSelected extends React.Component {

    render () {
        const {value} = this.props;
        const account = value
        const id = `${account.id}_Selected`;
        const accountIban = getLastNChars(account.iban);

        return (
            <div id={id} className="Select-value dropdown-accounts__account">
                <div className="Select-value-label">
                    <div className="dropdown-accounts__account-description">
                        <span className="dropdown-accounts__account-description-alias">{account.alias}</span>
                        <span className="dropdown-accounts__account-description-iban" > {accountIban}</span>
                        <span className="dropdown-accounts__account-description-separator"> {HYPHEN} </span>
                        <span className="dropdown-accounts__account-description-type">{account.type} </span>
                    </div>
                </div>
            </div>
        );
    }
}

AccountItemSelected.propTypes = {
    value: PropTypes.object
};

module.exports = AccountItemSelected;
